import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { ICardProps } from './types';

import styles from './Card.module.scss';

export const Card: React.FC<ICardProps> = ({ title, subtitle, className, children, ...props }) => {
  return (
    <Box {...props} className={clsx(styles.container, className)}>
      {title && (
        <Box className={styles.titleContainer} sx={{ marginBottom: subtitle ? 0.5 : 3 }}>
          <Typography variant="h6">{title}</Typography>
        </Box>
      )}

      {children}
    </Box>
  );
};
